import { Upload, Button } from "antd";
import { useState, useEffect } from "react";
import { error, success } from "../../contants/snackbars";
import { postVideo } from "../../stores/api_calls/upload";
import { MdOutlineFileUpload } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { colorScheme } from "../../contants/variables";

const VideoUploader = ({localVideoUrl, handelVideoChange}) => {
    const [videoFile, setVideoFile] = useState(null);

    const handleChangeVideo = ({ videoFile: newVideoList }) => {
        setVideoFile(newVideoList);
    };

    const handleVideoFileUpload = async ({file, onSuccess, onError}) => {
        
        try {
        const res = await postVideo(file);
        
        if (res?.data?.success) {
            onSuccess(null, file);
            handelVideoChange("localVideoUrl", res?.data?.data?.metadata?.file_url);
        } else {
            throw new Error('Upload failed');
        }
        } catch (e) {
        onError(e);
        error(
            e.message || 'Upload failed!'
        );
        console.log(e);
        }
    }

    const beforeUploadVideo = async (file) => {
        const isMP4 = file.type === 'video/mp4';

        if (!isMP4) {
        error('Only MP4 files are allowed!');
        handelVideoChange("localVideoUrl", null);
        setVideoFile([]);
        return Upload.LIST_IGNORE; // Prevent the file from being added to the list
        }

        const isValid = await validateVideoDuration(file);
        if (!isValid) {
        error('Video duration must not exceed 3 minutes!');
        handelVideoChange("localVideoUrl", null);
        setVideoFile([]);
        return false;
        }

        const previewURL = URL.createObjectURL(file);
        handelVideoChange("localVideoUrl", previewURL);

        return true; // Allow the upload
    }

    const validateVideoDuration = (file) => {
        return new Promise((resolve) => {
        const video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
            URL.revokeObjectURL(video.src);
            resolve(video.duration <= 180); // Check if duration is <= 60 seconds
        };

        video.onerror = () => {
            error('Unable to load video metadata.');
            resolve(false);
        };

        video.src = URL.createObjectURL(file);
        });
    };

    const handleClear = () => {
        handelVideoChange("localVideoUrl", null);
        setVideoFile(null);
    };

    return (
        <>
        <div style={{display:'flex', justifyContent:'space-between'}}>
            {!localVideoUrl && (
            <div>
                <Upload
                accept="video/mp4"
                onChange={handleChangeVideo}
                customRequest={handleVideoFileUpload}
                beforeUpload={beforeUploadVideo}
                fileList={videoFile}
                >
                <Button type="primary">
                    <MdOutlineFileUpload style={{marginRight:10}} /> <span>Upload Video</span>
                </Button>
                </Upload>
                <p className="form-field-label" style={{color:colorScheme.red, fontSize:12, marginTop:3}}>Video duration must not exceed 3 minutes!</p>
            </div>
            )}

            {localVideoUrl && (
            <div style={{ marginLeft: '20px',display:'flex' }}>
                <video
                src={localVideoUrl}
                controls
                width="150"
                style={{ border: '1px solid #ccc', borderRadius: '4px' }}
                />
                <IoIosCloseCircleOutline
                onClick={handleClear}
                style={{color:'red',fontSize:20,cursor:'pointer'}}
                />
            </div>
            )}
        </div>
        </>
    );
}

export default VideoUploader;